module.exports = __webpack_public_path__ + "static/img/guidance12.a46f033a.png";